import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {getCookie} from "../helpers/utils";

@Injectable({
  providedIn: 'root'
})
export class PlayerReplacerService {

  private _getAvailableSubstitutesURLBase: string = '/api/v1/not_finish_ds/';
  private _substitutePlayerURLBase: string = '/api/v1/change_ds_player_place/';
  private _formattedDictOfSubstitutes = {};
  private _tournamentIdentifier: number;
  private _mountedComponentInstances: number = 0;
  private _listOfPlayersToIgnore: string[] = [];
  constructor(
    private http: HttpClient
  ) { }

  private getCsrfToken(): string {
    return getCookie('csrftoken');
  }

  private getAvailableSubstitutesListURL(tournamentIdentifier: number): string {
    return `${this._getAvailableSubstitutesURLBase}${tournamentIdentifier}/`;
  }

  private getSubstitutePlayerURL(tournamentIdentifier: number): string {
    return `${this._substitutePlayerURLBase}${tournamentIdentifier}/`;
  }

  getListOfSubstitutes() {
    return this.http.get(
      this.getAvailableSubstitutesListURL(this.tournamentIdentifier),
      {
        headers: {
          'X-CSRFToken': this.getCsrfToken(),
        }
      },
    )
  }

  substitute(data: fullSubstitutionDataToSend) {
    return this.http.put(
      this.getSubstitutePlayerURL(this.tournamentIdentifier),
      {
        ...data
      }, {
        headers: {
          'X-CSRFToken': this.getCsrfToken(),
        }
      }
    );
  }

  get formattedDictOfSubstitutes() {
    return this._formattedDictOfSubstitutes;
  }

  set formattedDictOfSubstitutes(object) {
    this._formattedDictOfSubstitutes = object;
  }

  get tournamentIdentifier(): number {
    return this._tournamentIdentifier;
  }

  set tournamentIdentifier(value) {
    this._tournamentIdentifier = value;
  }

  get mountedComponentInstances(): number {
    return this._mountedComponentInstances;
  }

  set mountedComponentInstances(value) {
    this._mountedComponentInstances = value;
  }

  get listOfPlayersToIgnore(): string[] {
    return  [...this._listOfPlayersToIgnore];
  }

  set listOfPlayersToIgnore(list) {
    this._listOfPlayersToIgnore = [...list];
  }
}


interface substituteData {
  player_id: number,
  ds_number: number,
  full_name: string,
}

export default interface backendResponseData {
  results: substituteData[],
  results_len?: number,
}

export interface fullSubstitutionDataToSend {
  ds_from_player: number,
  ds_to_player: number,
  ds_from_num: number,
  ds_to_num: number,
}

